import React, { useState, useEffect } from "react";
import { Button, Modal } from "antd";
import './kyc-dialog.scss';

export default function KycDialog({ isOpen, onOk, onCancel, prompt }) {

  return (
    <Modal
      open={isOpen}
      title={<p class="kyc-dialog-title">{prompt?.title || ''}</p>}
      onOk={onOk}
      onCancel={onCancel}
      maskClosable={true}
      closable={true}
      className="kyc-dialog"
      footer={[
        <Button key="submit" onClick={onOk} className="kyc-dialog-btn">
          Got it
        </Button>,
      ]}
    >
      <div className="kyc-dialog-content">
        <p>
          {prompt?.content || ''}
        </p>

        <p style={{color: '#6f7280'}}>
          Download the Teleport Now App to perform KYC.
        </p>

        <div className="store-buttons">
          <a
            className="app-store-button"
            href="https://apps.apple.com/us/app/teleport-now/id6756201717"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/appstore.svg" alt="App Store" />
          </a>

          <a
            className="play-store-button"
            href="https://play.google.com/store/apps/details?id=sg.teleportnow.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/playstore.svg" alt="Google Play Store" />
          </a>
        </div>
      </div>
    </Modal>
  );
}
